var render, staticRenderFns
import script from "./print-head.vue?vue&type=script&lang=js"
export * from "./print-head.vue?vue&type=script&lang=js"
import style0 from "./print-head.vue?vue&type=style&index=0&id=4b3c2246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c2246",
  null
  
)

export default component.exports